"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columns = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const strings_1 = require("../../../../../constants/strings");
const lexico = new lexico_1.default();
exports.columns = [
    {
        id: 'last4Digits',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 1,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Last 4 digits of the card') }) }));
        },
    },
    {
        id: 'teamName',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Team') }) }));
        },
    },
    {
        id: 'cardRequester',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Member') }) }));
        },
    },
    {
        id: 'cardName',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: strings_1.walletStrings.BUSINESS_JUSTIFICATION }) }));
        },
    },
    {
        id: 'cardUsage',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Type') }) }));
        },
    },
    {
        id: 'approvedAmount',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Total') }) }));
        },
    },
    {
        id: 'spentAmount',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Spent') }) }));
        },
    },
    {
        id: 'availableAmount',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Remaining balance') }) }));
        },
    },
    {
        id: 'expiryDate',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('End date') }) }));
        },
    },
    {
        id: 'cardStatus',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Status') }) }));
        },
    },
    {
        id: 'actions',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Actions') }) }));
        },
    },
];
